import * as React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Chart from './Chart';
import TrackingTable from './TrackingTable';
import Conversion from './Conversion';
import axios from 'axios';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

const mdTheme = createTheme();

function SearchAdsAdvance() {
  const [rows, setRows] = React.useState([]);
  const [selectedValue, setSelectedValue] = React.useState(2);
  const [chartData, setChartData] = React.useState([]);
  const [totalConversion, setTotalConversion] = React.useState(0);

  React.useEffect(() => {
    let from, to;
    const now = new Date();

    if (selectedValue === 0) {
      let today = new Date();
      today.setDate(now.getDate() - 1);
      today.setHours(0, 0, 0, 0);
      from = today.getTime();
      today.setHours(23, 59, 59, 999);
      to = today.getTime();
    } else if (selectedValue === 1) {
      from = now.getTime() - 3 * 24 * 3600 * 1000;
      to = now.getTime();
    } else if (selectedValue === 2) {
      from = now.getTime() - 7 * 24 * 3600 * 1000;
      to = now.getTime();
    } else if (selectedValue === 3) {
      from = now.getTime() - 30 * 24 * 3600 * 1000;
      to = now.getTime();
    } else {
      from = now.getTime() - 90 * 24 * 3600 * 1000;
      to = now.getTime();
    }

    axios.get(`${window.domain}/api/searchAdsAdvanceLogs?from=${from}&to=${to}`).then(logData => {
      setRows(logData.data.data);
      setChartData(logData.data.chart.data);
      let total = 0;
      logData.data.data.map(row => total = total + row.conversions.length);
      setTotalConversion(total);
    });
  }, [selectedValue]);

  return (
    <ThemeProvider theme={mdTheme}>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Grid container spacing={3}>
          {/* Chart */}
          <Grid item xs={12} md={8} lg={9}>
            <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column', height: 240 }}>
              <Chart data={chartData} />
            </Paper>
          </Grid>
          {/* Summary */}
          <Grid item xs={12} md={4} lg={3}>
            <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column', height: 240 }}>
              <Conversion total={totalConversion} />
            </Paper>
          </Grid>
          {/* Select date range */}
          <Grid item xs={12} justifyContent="flex-end">
            <FormControl sx={{ m: 1, minWidth: 120 }}>
              <InputLabel id="select-date-range">Select</InputLabel>
              <Select
                labelId="select-date-range"
                id="select-date-range"
                value={selectedValue}
                label="Select"
                autoWidth
                onChange={event => setSelectedValue(event.target.value)}
              >
                <MenuItem value={0}>Yesterday</MenuItem>
                <MenuItem value={1}>Last 3 days</MenuItem>
                <MenuItem value={2}>Last 7 days</MenuItem>
                <MenuItem value={3}>Last 30 days</MenuItem>
                <MenuItem value={4}>Last 90 days</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {/* Tracking table */}
          <Grid item xs={12}>
            <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
              <TrackingTable rows={rows} />
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </ThemeProvider>
  );
}

export default SearchAdsAdvance;